// extracted by mini-css-extract-plugin
export default {"container":"StrikeOffVoter_container__8U+Gk","title":"StrikeOffVoter_title__VDR-W","section":"StrikeOffVoter_section__zOg8J"};